"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_ANALYTICS_PERMISSIONS = exports.AnalyticsPermissions = void 0;
/**
 * Permission catalog for the Reports & Analytics module.
 *
 * WHY A FAMILY OF ITS OWN, rather than reusing a domain's read permission.
 *
 * These three reports read ACROSS bounded contexts — a registration count, an
 * appointment's revisit type and a day's collections are owned by three
 * different modules — so there is no single existing permission that means
 * "may read the hospital's operational reports". Gating them on, say,
 * `patient:search` would hand every registration clerk the collection report,
 * and gating them on `financial:op-register:view` would hide the registration
 * report from the people who register patients. A cross-cutting surface needs a
 * cross-cutting key.
 *
 * VIEW IS NOT EXPORT, deliberately — the same distinction ADR-084 §7 draws on
 * the OP Billing Register. Reading a report at a shift handover and extracting
 * the hospital's revenue book to a file are different acts with different
 * consequences, and one permission for both means the safer of the two can
 * never be granted alone.
 *
 * SCOPE IS NOT DECIDED HERE. The Collections report additionally narrows to the
 * caller's own takings unless they hold `financial:op-register:view-all` — see
 * `resolveReportScope`, which this module reuses rather than inventing a second
 * deny-by-default rule that could drift from the first.
 *
 * REGISTERING THIS CATALOG TAKES TWO EDITS, and doing only the first is
 * completely silent: `PermissionService.seedAnalyticsCatalog()` and the string
 * `'seedAnalyticsCatalog'` in `scripts/deploy-seed-all-catalogs.ts`'s
 * `CATALOG_SEEDERS`. Without the second, every `/analytics` route 403s for
 * every caller including SuperAdmin (BUG-0006's shape). The gate that asserts
 * both is `tests/unit/modules/analytics/analytics-permission-catalog.test.ts`.
 */
exports.AnalyticsPermissions = {
    /** Read any Reports & Analytics report. The module gate. */
    ANALYTICS_REPORT_VIEW: 'analytics:report:view',
    /** Extract a report to CSV. Never implied by view — see the file header. */
    ANALYTICS_REPORT_EXPORT: 'analytics:report:export',
};
/** Every Reports & Analytics permission, flattened — used to seed the `permissions` table. */
exports.ALL_ANALYTICS_PERMISSIONS = Object.values(exports.AnalyticsPermissions);
//# sourceMappingURL=analytics.permissions.js.map